import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
// import TakeYourBusinesSection from "./TakeYourBusinesSection";
// import WhatYouGetSection from "./WhatYouGetSection";
// import PerfectForSection from "./PerfectForSection";
// import WhyYearWorthSection from "./WhyYearWorthSection/WhyYearWorthSection";
// import PaymentSuccess  from "./SuccessPage/index";
import Preloader from "../Components/Preloader/Preloader";
import SuccessPage from "./SuccessPage";
import FailedPage from "./FailedPage";
import ProtectedRoute from "./ProtectedRoute";
import WhatsappButton from "./WhatsappButton/WhatsappButton";
import AboutUs from "./AboutUs/AboutUs";
import TermsConditions from "./TermsConditions/TermsConditions";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./RefundPolicy/RefundPolicy";
const Home = lazy(() => import("./Home"));

export const Layout = () => {
  return (
    <div>
      <div>
        <main>
          {/* <TakeYourBusinesSection /> */}
          {/* <WhatYouGetSection /> */}
          {/* <PerfectForSection />
          <WhyYearWorthSection /> */}

          <Suspense fallback={<Preloader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/about-us" element={<AboutUs />} /> */}
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route
                path="/payment-success"
                element={
                  <ProtectedRoute>
                    <SuccessPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment-failed"
                element={
                  <ProtectedRoute>
                    <FailedPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Suspense>
        </main>
        <WhatsappButton />
      </div>
    </div>
  );
};
